import React, { FC } from 'react'
import { FormControl, FormControlProps } from '@mui/material'

export const EvtFormControl: FC<FormControlProps> = ({ children, ...props }) => {
    return <FormControl {...props}>{children}</FormControl>
}

export default EvtFormControl
